export default __webpack_public_path__ + "static/media/My-coupon.92111d0a.jpg";